@if (data) {
    @if (data.templateRef) {
        <ng-container [ngTemplateOutlet]="data.templateRef"></ng-container>
    } @else {
        <ng-template #dynamicContent></ng-template>
    }
}
